import { useState } from "react";
import api from "../../utils/api";

export default function AddEarning({ contentOwnerId, onSuccess }) {
  const [date, setDate] = useState("");
  const [totalEarning, setTotalEarning] = useState("");
  const [platformCommission, setPlatformCommission] = useState("");

  const netEarning =
    totalEarning && platformCommission
      ? parseFloat(totalEarning) - parseFloat(platformCommission)
      : 0;

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!date || !totalEarning || !platformCommission) {
      alert("All fields are required.");
      return;
    }

    try {
      await api.post(
        "/earnings",
        {
          date,
          totalEarning: parseFloat(totalEarning),
          platformCommission: parseFloat(platformCommission),
          netEarning,
          contentOwnerId,
        },
        { withCredentials: true },
      );

      alert("Earning added successfully!");
      setDate("");
      setTotalEarning("");
      setPlatformCommission("");

      if (onSuccess) onSuccess();
    } catch (error) {
      console.error(error.response?.data || error.message);
      alert(error.response?.data?.message || error.message);
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="max-w-md mx-auto bg-white rounded-2xl shadow-sm border border-gray-200 p-6"
    >
      <h2 className="text-xl font-semibold text-gray-800 mb-6">Add Earning</h2>

      <div className="mb-5">
        <label className="block text-sm font-medium text-gray-600 mb-1">
          Date
        </label>
        <input
          type="date"
          value={date}
          onChange={(e) => setDate(e.target.value)}
          className="w-full rounded-lg border border-gray-300 px-3 py-2 text-gray-800
                 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        />
      </div>

      <div className="mb-5">
        <label className="block text-sm font-medium text-gray-600 mb-1">
          Total Earning
        </label>
        <input
          type="text"
          placeholder="0.00"
          value={totalEarning}
          onChange={(e) => setTotalEarning(e.target.value)}
          className="w-full rounded-lg border border-gray-300 px-3 py-2 text-gray-800
                 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        />
      </div>

      <div className="mb-5">
        <label className="block text-sm font-medium text-gray-600 mb-1">
          Platform Commission
        </label>
        <input
          type="text"
          placeholder="0.00"
          value={platformCommission}
          onChange={(e) => setPlatformCommission(e.target.value)}
          className="w-full rounded-lg border border-gray-300 px-3 py-2 text-gray-800
                 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        />
      </div>

      <div className="mb-6">
        <label className="block text-sm font-medium text-gray-600 mb-1">
          Net Earning (Auto-calculated)
        </label>
        <div className="w-full rounded-lg border border-gray-300 px-3 py-2 bg-gray-50 text-gray-800">
          ${netEarning.toFixed(2)}
        </div>
      </div>

      <button
        type="submit"
        className="w-full rounded-lg bg-green-500 py-2.5 text-white font-medium
               hover:bg-green-700 transition"
      >
        Add Earning
      </button>
    </form>
  );
}
